/* Before/after comparison slider. Moved out of sections/before-after-comparison.liquid on 2026-09-06 (was an 8 KB inline script per section). */
window.optInitBeforeAfter = function (sectionId, initialPosition) {
      // Initialize slider functionality for one section
      const container = document.getElementById('sliderContainer' + sectionId);
      if (!container || container.dataset.inited) return;
      container.dataset.inited = 'true';
      
      let sliderPosition = initialPosition; // Start position from settings
      let isDragging = false;
      let touchStartX = 0;
      let touchStartY = 0;
      let touchStartTime = 0;
      let hasMovedHorizontally = false;
      let isScrolling = null;
      
      // Get DOM elements
      const beforeImage = document.getElementById('beforeImage' + sectionId);
      const sliderLine = document.getElementById('sliderLine' + sectionId);
      const sliderButton = document.getElementById('sliderButton' + sectionId);
      
      if (!beforeImage || !sliderLine || !sliderButton) return;
      
      // Update slider position
      function updateSliderPosition(percentage) {
        // Clamp percentage between 0 and 100
        percentage = Math.max(0, Math.min(100, percentage));
        sliderPosition = percentage;
        
        // Update elements
        beforeImage.style.clipPath = `inset(0 ${100 - percentage}% 0 0)`;
        sliderLine.style.left = percentage + '%';
        sliderButton.style.left = percentage + '%';
        sliderButton.setAttribute('aria-valuenow', percentage);
        
        // Force reflow to ensure immediate update
        sliderButton.offsetLeft;
        sliderLine.offsetLeft;
      }
      
      // Get mouse/touch position relative to container
      function getPositionFromEvent(e, container) {
        const rect = container.getBoundingClientRect();
        const clientX = e.type && e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
        const offsetX = clientX - rect.left;
        return Math.max(0, Math.min(100, (offsetX / rect.width) * 100));
      }
      
      // Reset touch state
      function resetTouchState() {
        isDragging = false;
        touchStartX = 0;
        touchStartY = 0;
        touchStartTime = 0;
        hasMovedHorizontally = false;
        isScrolling = null;
        sliderButton.classList.remove('dragging');
        sliderButton.style.transition = '';
      }
      
      // Keyboard accessibility
      function handleKeyDown(e) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
        
        e.preventDefault();
        let newPosition = sliderPosition;
        
        switch(e.key) {
          case 'ArrowLeft':
            newPosition = Math.max(0, sliderPosition - 5);
            break;
          case 'ArrowRight':
            newPosition = Math.min(100, sliderPosition + 5);
            break;
          case 'Home':
            newPosition = 0;
            break;
          case 'End':
            newPosition = 100;
            break;
        }
        
        updateSliderPosition(newPosition);
      }
      
      // Mouse events
      function handleMouseDown(e) {
        e.preventDefault();
        isDragging = true;
        sliderButton.classList.add('dragging');
        sliderButton.style.transition = 'none';
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
      }
      
      function handleMouseMove(e) {
        if (!isDragging) return;
        const percentage = getPositionFromEvent(e, container);
        updateSliderPosition(percentage);
      }
      
      function handleMouseUp() {
        isDragging = false;
        sliderButton.classList.remove('dragging');
        sliderButton.style.transition = '';
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
      }
      
      // Touch events
      function handleTouchStart(e) {
        const touch = e.touches[0];
        const rect = container.getBoundingClientRect();
        const touchX = touch.clientX - rect.left;
        const touchY = touch.clientY - rect.top;
        
        // Check if touch is within container bounds
        if (touchX < 0 || touchX > rect.width || touchY < 0 || touchY > rect.height) {
          return;
        }
        
        // Reset state
        resetTouchState();
        
        // Set initial touch values
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        touchStartTime = Date.now();
        isDragging = true;
        isScrolling = null;
        hasMovedHorizontally = false;
        
        sliderButton.classList.add('dragging');
        sliderButton.style.transition = 'none';
        
        // Add touch event listeners
        document.addEventListener('touchmove', handleTouchMove, { passive: false });
        document.addEventListener('touchend', handleTouchEnd, { passive: true });
        document.addEventListener('touchcancel', handleTouchCancel, { passive: true });
      }
      
      function handleTouchMove(e) {
        if (!isDragging) return;
        
        const touch = e.touches[0];
        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;
        const absDeltaX = Math.abs(deltaX);
        const absDeltaY = Math.abs(deltaY);
        
        // Determine scroll direction on first significant movement
        if (isScrolling === null && (absDeltaX > 5 || absDeltaY > 5)) {
          isScrolling = absDeltaY > absDeltaX;
        }
        
        // If user is scrolling vertically, cancel slider interaction
        if (isScrolling) {
          resetTouchState();
          document.removeEventListener('touchmove', handleTouchMove);
          document.removeEventListener('touchend', handleTouchEnd);
          document.removeEventListener('touchcancel', handleTouchCancel);
          return;
        }
        
        // If moving horizontally, prevent default scrolling and update slider
        if (absDeltaX > 5) {
          e.preventDefault();
          hasMovedHorizontally = true;
          const percentage = getPositionFromEvent(e, container);
          updateSliderPosition(percentage);
        }
      }
      
      function handleTouchEnd(e) {
        if (!isDragging) return;
        
        // Clean up event listeners
        document.removeEventListener('touchmove', handleTouchMove);
        document.removeEventListener('touchend', handleTouchEnd);
        document.removeEventListener('touchcancel', handleTouchCancel);
        
        // If it was a quick tap without horizontal movement, treat as click
        const touchDuration = Date.now() - touchStartTime;
        if (touchDuration < 200 && !hasMovedHorizontally && !isScrolling) {
          const percentage = getPositionFromEvent(e.changedTouches[0], container);
          updateSliderPosition(percentage);
        }
        
        resetTouchState();
      }
      
      function handleTouchCancel() {
        document.removeEventListener('touchmove', handleTouchMove);
        document.removeEventListener('touchend', handleTouchEnd);
        document.removeEventListener('touchcancel', handleTouchCancel);
        resetTouchState();
      }
      
      // Container click/tap events
      function handleContainerClick(e) {
        // Don't handle if clicking on slider button
        if (e.target === sliderButton || sliderButton.contains(e.target)) return;
        
        // Don't handle if this was part of a drag gesture
        if (hasMovedHorizontally) return;
        
        const percentage = getPositionFromEvent(e, container);
        updateSliderPosition(percentage);
      }
      
      // Attach event listeners
      sliderButton.addEventListener('mousedown', handleMouseDown);
      sliderButton.addEventListener('touchstart', handleTouchStart, { passive: true });
      sliderButton.addEventListener('keydown', handleKeyDown);
      
      container.addEventListener('mousedown', function(e) {
        if (e.target === sliderButton || sliderButton.contains(e.target)) return;
        handleMouseDown(e);
      });
      
      container.addEventListener('touchstart', function(e) {
        if (e.target === sliderButton || sliderButton.contains(e.target)) return;
        handleTouchStart(e);
      }, { passive: true });
      
      container.addEventListener('click', handleContainerClick);
      
      // Initialize position
      updateSliderPosition(initialPosition);
};
